// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { irishjobs as baseIrishjobsTheme } from "@stepstone-genesis/design-tokens";
var irishjobs = extendBaseTheme("irishjobs", baseIrishjobsTheme);
export {
  irishjobs
};
